import Vue from 'vue';
import GoogleMap from 'vuejs-google-maps';
import 'vuejs-google-maps/dist/vuejs-google-maps.css'

export default () => {
    const { apiKey, libraries } = {"apiKey":"AIzaSyB1Lqi1lmuakmc8PeMPUyDjuJphgxybS9w","libraries":["places"]} || {}
    Vue.use(GoogleMap, {
        load: {
            apiKey,
            libraries
        }
    });
}
